<template>
    <b-container fluid>
        <b-row align-v="center">
            <b-col cols="12" md="12">
                <app-form-input label="Título / Descripción" placeholder="Buscar..." v-model="taskFilters.term" @keyup.enter="filter()"></app-form-input>
            </b-col>
            <b-col cols="12" md="12">
                <app-form-select
                    v-model="taskFilters.venueId"
                    resource="venues"
                    label="Sede"
                    :hard-filters="{ clientId: this.currentClient.id }"
                    @keyup.enter="filter()"
                ></app-form-select>
            </b-col>
            <b-col cols="12" md="4">
                <app-form-input label="Ticket PQR" v-model="taskFilters.petitionCode" @keyup.enter="filter()"></app-form-input>
            </b-col>
            <b-col cols="12" md="4">
                <app-form-select
                    v-model="taskFilters.userId"
                    resource="users"
                    label="Responsable"
                    :hard-filters="{ clientId: this.currentClient.id }"
                    @keyup.enter="filter()"
                ></app-form-select>
            </b-col>
            <b-col cols="12" md="4">
                <app-form-select
                    v-model="taskFilters.createdById"
                    resource="users"
                    label="Creada por"
                    :hard-filters="{ clientId: this.currentClient.id }"
                    @keyup.enter="filter()"
                ></app-form-select>
            </b-col>
            <b-col cols="12" md="4">
                <app-form-select
                    v-model="taskFilters.positionId"
                    resource="positions"
                    label="Cargo"
                    :hard-filters="{ clientId: this.currentClient.id }"
                    @keyup.enter="filter()"
                ></app-form-select>
            </b-col>
            <!-- <b-col cols="12" md="4">
                <label for="end-datepicker">Fecha de vencimiento</label>
                <b-form-datepicker id="end-datepicker" v-model="taskFilters.finishDate" class="mb-2"></b-form-datepicker>
            </b-col> -->
            <b-col cols="12" md="8">
                <label>Fecha de vencimiento</label>
                <b-row>
                    <b-col>
                        <b-form-datepicker
                            v-model="taskFilters.dueFromDate"
                            placeholder="Desde"
                            class="mb-2"
                        ></b-form-datepicker>
                    </b-col>
                    <b-col>
                        <b-form-datepicker
                            v-model="taskFilters.dueToDate"
                            placeholder="Hasta"
                            class="mb-2"
                        ></b-form-datepicker>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="right-spaced">
                <b-btn variant="primary" class="btn-block-xs-only" size="sm" @click="filter"><i class="fas fa-filter"></i></b-btn>
                <b-btn variant="secondary" class="btn-block-xs-only" size="sm" @click="clear"><i class="fas fa-times"></i></b-btn>
                <app-btn-excel class="btn-block-xs-only" @click="onDownloadReport"></app-btn-excel>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
export default {
    data: () => ({
        taskFilters: {
            term: '',
            petitionCode: '',
            venueId: '',
            userId: '',
            positionId: '',
            dueFromDate: '',
            dueToDate: '',
            status: '',
            createdById: '',
        },
        // Opciones para el select de estado
        statusOptions: [
            { value: 'pending', text: 'Pendiente' },
            { value: 'in_progress', text: 'En progreso' },
            { value: 'defeated', text: 'Vencida' },
            { value: 'finished', text: 'Finalizada' }
        ],
    }),
    methods: {
        filter() {
            this.$emit('filters', this.taskFilters)
        },
        clear() {
            Object.keys(this.taskFilters).map((key) => (this.taskFilters[key] = ''))
            this.$emit('clear')
        },

        onDownloadReport() {
            const filters = {
                clientId: this.currentClient.id,
                ...this.taskFilters,
            }
            const params = []
            _.forIn(filters, (value, key) => {
                if (!value) return
                params.push(`${key}=${value}`)
            })

            const queryString = params.join('&')
            window.open(`web/v1/downloads/tasks-report?` + queryString, '_blank')
        },

    },
}
</script>
